module.exports = __webpack_public_path__ + "static/aimee_liu-1c7f8cfe2c50099f8140089bfad03ea0.jpg";